

import { Button } from '@/components/ui/button';

interface NodeControlsProps {
  onAddNode: (type: string) => void;
}

export function NodeControls({ onAddNode }: NodeControlsProps) {
  return (
    <div className="node-controls flex gap-2 mb-2">
      <Button size="sm" onClick={() => onAddNode('positionNode')}>Add Position</Button>
      <Button size="sm" onClick={() => onAddNode('techniqueNode')}>Add Technique</Button>
      <Button size="sm" onClick={() => onAddNode('conditionalNode')}>Add Conditional</Button>
    </div>
  );
}
